/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractSummary } from './ContractSummary';
import {
    ContractSummaryFromJSON,
    ContractSummaryFromJSONTyped,
    ContractSummaryToJSON,
    ContractSummaryToJSONTyped,
} from './ContractSummary';
import type { PalSubmissionListEntryTimExecutionReportResult } from './PalSubmissionListEntryTimExecutionReportResult';
import {
    PalSubmissionListEntryTimExecutionReportResultFromJSON,
    PalSubmissionListEntryTimExecutionReportResultFromJSONTyped,
    PalSubmissionListEntryTimExecutionReportResultToJSON,
    PalSubmissionListEntryTimExecutionReportResultToJSONTyped,
} from './PalSubmissionListEntryTimExecutionReportResult';
import type { PalSubmissionListEntryTimExecutionPayor } from './PalSubmissionListEntryTimExecutionPayor';
import {
    PalSubmissionListEntryTimExecutionPayorFromJSON,
    PalSubmissionListEntryTimExecutionPayorFromJSONTyped,
    PalSubmissionListEntryTimExecutionPayorToJSON,
    PalSubmissionListEntryTimExecutionPayorToJSONTyped,
} from './PalSubmissionListEntryTimExecutionPayor';

/**
 * Subset of TimExecution for list view (from original PAL submission)
 * @export
 * @interface PalReauthSubmissionListEntryTimExecution
 */
export interface PalReauthSubmissionListEntryTimExecution {
    /**
     * 
     */
    payor?: PalSubmissionListEntryTimExecutionPayor;
    /**
     * 
     */
    insurance_type?: string;
    /**
     * 
     */
    reimbursement_type?: string;
    /**
     * 
     */
    report_result?: PalSubmissionListEntryTimExecutionReportResult;
    /**
     * 
     */
    contract?: ContractSummary;
}

/**
 * Check if a given object implements the PalReauthSubmissionListEntryTimExecution interface.
 */
export function instanceOfPalReauthSubmissionListEntryTimExecution(value: object): value is PalReauthSubmissionListEntryTimExecution {
    return true;
}

export function PalReauthSubmissionListEntryTimExecutionFromJSON(json: any): PalReauthSubmissionListEntryTimExecution {
    return PalReauthSubmissionListEntryTimExecutionFromJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryTimExecutionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionListEntryTimExecution {
    if (json == null) {
        return json;
    }
    return {
        
        'payor': json['payor'] == null ? undefined : PalSubmissionListEntryTimExecutionPayorFromJSON(json['payor']),
        'insurance_type': json['insurance_type'] == null ? undefined : json['insurance_type'],
        'reimbursement_type': json['reimbursement_type'] == null ? undefined : json['reimbursement_type'],
        'report_result': json['report_result'] == null ? undefined : PalSubmissionListEntryTimExecutionReportResultFromJSON(json['report_result']),
        'contract': json['contract'] == null ? undefined : ContractSummaryFromJSON(json['contract']),
    };
}

export function PalReauthSubmissionListEntryTimExecutionToJSON(json: any): PalReauthSubmissionListEntryTimExecution {
    return PalReauthSubmissionListEntryTimExecutionToJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryTimExecutionToJSONTyped(value?: PalReauthSubmissionListEntryTimExecution | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payor': PalSubmissionListEntryTimExecutionPayorToJSON(value['payor']),
        'insurance_type': value['insurance_type'],
        'reimbursement_type': value['reimbursement_type'],
        'report_result': PalSubmissionListEntryTimExecutionReportResultToJSON(value['report_result']),
        'contract': ContractSummaryToJSON(value['contract']),
    };
}

